module.exports = "../../../../platform/assets/pageMainIcon/industry_yewushezhilei5.svg";